export const BannerDismissedKeyBase = 'ARCADE_INTRO_BANNER_DISMISSED';
